export const highlighter = (content, highlight) => {
  let newContent = content;

  if (highlight)
    highlight.forEach((item) => {
      newContent = newContent?.replace(
        new RegExp(`( ${item?.text} )`, 'g'),
        `<span style="background-color:${item?.color}">&nbsp;${item?.text}&nbsp;</span>`
      );
    });

  return newContent;
};
